import { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Custom pin icons (avoid missing default marker asset issues)
function pin(color) {
  return L.divIcon({
    className: "",
    html: `<div style="width:26px;height:26px;border-radius:50% 50% 50% 0;background:${color};transform:rotate(-45deg);box-shadow:0 2px 6px rgba(0,0,0,.35);border:2px solid #fff"></div>`,
    iconSize: [26, 26], iconAnchor: [13, 26], popupAnchor: [0, -24],
  });
}

export default function MiniMap({ center, markers = [], route, height = 220 }) {
  const ref = useRef(null);
  const mapRef = useRef(null);

  useEffect(() => {
    if (!ref.current || !center || center[0] == null) return;
    if (mapRef.current) { mapRef.current.remove(); mapRef.current = null; }
    const map = L.map(ref.current, { scrollWheelZoom: false, attributionControl: false }).setView(center, 14);
    L.tileLayer("https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png", { maxZoom: 19 }).addTo(map);
    const bounds = [];
    L.marker(center, { icon: pin("#062847") }).addTo(map).bindPopup("La tua struttura");
    bounds.push(center);
    markers.forEach((m) => {
      if (m.lat == null) return;
      L.marker([m.lat, m.lng], { icon: pin("#F79400") }).addTo(map)
        .bindPopup(`<b>${m.name}</b>${m.distance_km != null ? `<br/>${m.distance_km} km` : ""}`);
      bounds.push([m.lat, m.lng]);
    });
    if (route && route.length > 1) {
      L.polyline(route, { color: "#F79400", weight: 4, opacity: 0.85 }).addTo(map);
      route.forEach((p) => bounds.push(p));
    }
    if (bounds.length > 1) map.fitBounds(bounds, { padding: [30, 30], maxZoom: 16 });
    mapRef.current = map;
    const t = setTimeout(() => { try { map.invalidateSize(); } catch (e) {} }, 200);
    return () => { clearTimeout(t); if (mapRef.current) { mapRef.current.remove(); mapRef.current = null; } };
  }, [center, markers]);

  if (!center || center[0] == null) return null;
  return <div ref={ref} data-testid="mini-map" style={{ height, width: "100%", borderRadius: 16, overflow: "hidden", zIndex: 0 }} />;
}
